import PropTypes from "prop-types";
import SlideIn from "../../../Components/SlideIn/SlideIn";
import HowVerificationWorksContent from "./HowVerificationWorksContent";
import VerificationHelpFooter from "./VerificationHelpFooter";

const HowVerificationWorksSlideIn = ({ close }) => (
  <SlideIn
    close={close}
    contents={<HowVerificationWorksContent />}
    footer={<VerificationHelpFooter />}
  />
);

HowVerificationWorksSlideIn.propTypes = {
  close: PropTypes.func,
};

export default HowVerificationWorksSlideIn;
